import React from 'react';
import PropTypes from 'prop-types';
import ScriptLoader from 'react-script-loader-hoc';
import withGlobals from '../../components/Globals';
import AppWithoutServerlessCounselorCommunity from './app-without-serverless-cc';

const counselorCommunityUrl = process.env.COUNSELOR_COMMUNITY_URL;
/* istanbul ignore else */
if (counselorCommunityUrl) {
  const { origin } = new URL(counselorCommunityUrl);
  global.__webpack_counscomm_public_path__ = origin;
}

export const WithScriptCounselorCommunity = ({
  scriptsLoadedSuccessfully,
  ...rest
}) =>
  (scriptsLoadedSuccessfully ? (<AppWithoutServerlessCounselorCommunity {...rest} />) : null);

WithScriptCounselorCommunity.propTypes = {
  scriptsLoadedSuccessfully: PropTypes.bool,
};

export default withGlobals(ScriptLoader(counselorCommunityUrl)(WithScriptCounselorCommunity));
